import { NO_EMPLOYER_ONLY_STEPS, SIGNUP_STEPS, signupStepPath, type SignupStepId } from '../steps';

/**
 * The rewards steps explain rewards themselves, in the card's own words, so
 * the card would only repeat them there.
 */
const REWARDS_EXPLAINED_STEPS: ReadonlySet<SignupStepId> = new Set([
  'rewards-intro',
  'rewards-points',
]);

const FLOW_STEP_PATHS: ReadonlySet<string> = new Set(
  [...SIGNUP_STEPS, ...NO_EMPLOYER_ONLY_STEPS]
    .filter((step) => !REWARDS_EXPLAINED_STEPS.has(step))
    .map((step) => signupStepPath(step)),
);

/**
 * Whether the rewards card belongs on this page: the steps a member moves
 * through, on either path, except the rewards steps. Off-path pages (legal
 * documents, error, login) and the steps that end the flow (an age stop,
 * registered) never show it.
 */
export function isRewardsCarouselPath(pathname: string | null): boolean {
  if (pathname === null) return false;
  return FLOW_STEP_PATHS.has(pathname.endsWith('/') ? pathname : `${pathname}/`);
}
